import angular from 'angular';

angular.module('cxTranslations', []);
